import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, FlexSpan, Icon } from "../../ui";
import { InfoBlockContainer } from "./styled";
export const InfoBlock = ({ icon, iconSize, children }) => {
    return (_jsx(InfoBlockContainer, { children: _jsxs(Flex, { p: "1rem", alignItems: "flex-start", children: [_jsx(FlexSpan, { mr: "0.75rem", display: "flex", children: _jsx(Icon, { icon: icon ?? "info", color: "#9D87F1", size: iconSize }) }), _jsx(FlexSpan, { flexGrow: 1, children: children })] }) }));
};
